import { noraWebTheme } from "./noraWebTheme";
import createTheme from "@mui/material/styles/createTheme";

const BREAKPOINTS = {
  xs: 0,
  sm: 610,
  md: 920,
  lg: 1230,
  xl: 1540,
};
const breakpointsValues = {
  breakpoints: {
    values: BREAKPOINTS
  }
};
const MainBPTheme = createTheme({ ...noraWebTheme, ...breakpointsValues });

export default MainBPTheme;